import {lessons} from "../../proto/compiled";
import {Frame} from "../common/Frame";
import {LoadingOverlay} from "../common/LoadingOverlay";
import styled from "@emotion/styled";
import {Typography} from "@mui/material";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import {D} from "../../Constants";
import {theme} from "../../Theme";
import useWave from "use-wave";

interface Props {
  lesson?: lessons.ILesson;
  style?: React.CSSProperties;
  onClick?: () => any;
}

export const LessonCard = (props: Props) => {
  const wave = useWave();

  if (!props.lesson) {
    return <Container
      style={{backgroundColor: 'rgba(255, 255, 255, 0.3)', ...props.style}}
      row
      gap={2}
      padding={2}
      alignItems={'stretch'}
    >
      <Frame style={{aspectRatio: 1}}>
        <LoadingOverlay visible={true}/>
      </Frame>
      <Frame grow gap={2}>
        <Frame height={D.interactive()} width={D.interactive(10)}>
          <LoadingOverlay visible={true}/>
        </Frame>
        <Frame grow height={D.interactive()} style={{alignSelf: 'stretch'}}>
          <LoadingOverlay visible={true}/>
        </Frame>
      </Frame>
    </Container>;
  }
  const hasThumbnail = !!props.lesson.thumbnailUrl;

  return <Container
    ref={wave}
    style={props.style}
    gap={4}
    border={1}
    padding={2}
    row
    background={theme.palette.background.paper}
    clickable={!!props.onClick}
    onClick={props.onClick}
  >
    {hasThumbnail ? (
      <img style={{aspectRatio: 1, margin: D.unit(-2)}} src={props.lesson.thumbnailUrl!} alt={'Lesson Thumbnail'}/>
    ) : (
      <Frame
        center
        radius={0}
        style={{
          aspectRatio: 1,
          margin: D.unit(-2),
          backgroundColor: theme.palette.shade2,
        }}
      >
        <MenuBookIcon style={{fontSize: 64, color: theme.palette.primary.main, opacity: 0.5}}/>
      </Frame>
    )}
    <Frame style={{flex: 1}}>
      <Typography variant="h6">{props.lesson.title}</Typography>
      <Typography variant="body1" style={{marginTop: 8, flex: 1, textOverflow: 'ellipsis'}}>
        {props.lesson.description}
      </Typography>
    </Frame>
  </Container>;
};

const Container = styled(Frame)`
    height: 250px;
    overflow: hidden;
`;
